import {
  IPayoutSettingsResponse,
  PayoutDestinationType
} from "@wingspanhq/payments/dist/interfaces";
import { IMember } from "@wingspanhq/users/dist/lib/interfaces";
import type { onboardingApiSpec } from "@wingspanhq/wingspan-api-types";
import { selectorDefaultDestination } from "./selectorDefaultDestination";

export const selectorUseInternationalInstantPayouts = (
  member: IMember,
  monitoredEntity?: onboardingApiSpec.CustomerEntity,
  payoutSettings?: IPayoutSettingsResponse
) => {
  const defaultDestination = payoutSettings
    ? selectorDefaultDestination(payoutSettings)
    : undefined;

  if (
    defaultDestination?.destinationType ===
    ("InternalAccount" as PayoutDestinationType)
  ) {
    return true;
  }

  if (monitoredEntity?.country) {
    return monitoredEntity.country === "CA";
  }

  return member.profile.address?.country === "CA";
};
